"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = () => ({
    root: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
        zIndex: constants_1.VENEER_FIXED_ZINDEX,
        overflow: 'hidden'
    },
    content: {
        position: 'absolute',
        '&:focus': {
            outline: 'none'
        }
    },
    contentCentred: {
        top: '50%',
        left: '50%',
        transform: 'translateY(-50%) translateX(-50%)',
        maxWidth: `calc(100vw - ${constants_1.VIEWPORT_MARGIN * 2}px)`,
        maxHeight: `calc(100vh - ${constants_1.VIEWPORT_MARGIN * 2}px)`
    }
});
//# sourceMappingURL=veneer.style.js.map